import { useQuery } from '@apollo/client';

import { devicesClient, marketplaceClient as client } from '../graphql/apolloClientConfiguration';
import { getAllEquipmentCategories } from '../graphql/devices';
import { getServiceTypes } from '../graphql/marketplace';

export default (userId = null) => {
  const { loading, data: { serviceTypes } = {} } = useQuery(getServiceTypes, {
    variables: {
      userId,
    },
    client,
  });

  const { loading: categoriesAreLoading, data: { categories } = {} } = useQuery(getAllEquipmentCategories, {
    variables: {
      userId,
    },
    client: devicesClient,
  });

  return {
    loading,
    categoriesAreLoading,
    serviceTypes,
    categories,
  };
};
